import { PillVariant } from "../../widget";

export class ProjectStatusConstants {
  public static readonly DRAFT = "Draft";

  public static readonly PRE_DEVELOPMENT = "Pre-development";

  public static readonly UNDER_DEVELOPMENT = "Under Development";

  public static readonly VALIDATED = "Validated";

  public static readonly VALIDATION_PENDING = "Validation pending";

  public static readonly VERIFIED = "Verified";

  public static readonly VERIFICATION_PENDING = "Verification pending";

  public static readonly ONGOING_VERIFICATION = "Ongoing verification";

  public static readonly SETUP_IN_PROGRESS = "Setup in progress";

  public static readonly NOT_DELIVERED = "Not Delivered";

  public static readonly CANCELLED = "Cancelled";

  public static readonly RESTORATION_VALIDATED = "Restoration Validated";

  public static readonly REGISTRY_STATUS_LABEL = "Registry status";

  public static readonly LOOKUP_TYPE = "ProjectRegistryStatus";

  public static readonly CANCELLED_STATUSES = [ProjectStatusConstants.NOT_DELIVERED, ProjectStatusConstants.CANCELLED];

  public static readonly PROJECT_STATUS_PILL_VARIANT_MAP: { [key: string]: PillVariant } = {
    Draft: "grey",
    "Pre-development": "grey",
    "Under Development": "coral",
    Verified: "green",
    Validated: "green",
    "Restoration Validated": "green",
    "Not Delivered": "grey",
    Cancelled: "grey",
  };
}
